export default ({
  finalizePmc: {
      textAlign: 'center',
      textDecoration: 'none'
  },

  finalizePmcButtonGrid: {
    textAlign: 'center'
  }
})
